import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

export const Wrapper = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 128px;
  img {
    width: 100%;
    height: auto;
  }
  svg {
    margin-right: 16px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    width: 220px;
    svg{
      display: none;
    }
  }
`;
